<div [class]="mapWrapperClass">
  @if (apiLoaded$ | async) {
    <div class="google-map-container">
      <google-map #googleMap width="100%" [height]="mapHeight">
        @for (marker of markers; track marker) {
          <map-marker
            [position]="marker.position"
            [label]="marker.label"
            [title]="marker.title"
            [options]="marker.options"
          />
        }
      </google-map>
    </div>
  }
</div>
